// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-dialog {
    width: 450px;
}

.modal-dialog-wide {
    width: 550px;
}

.modal-dialog-header {
    display: flex;
    background-color: #0048a4;
    color: white;
    font-size: 18px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 62px;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.modal-dialog-body {
    display: flex;
    background-color: white;
    align-items: center;
    padding: 20px;
    border-bottom: 3px solid #f3f2f3;
    flex-wrap: wrap;
}

.modal-dialog-body-less-padding {
    display: flex;
    background-color: white;
    align-items: center;
    padding: 10px;
    border-bottom: 3px solid #f3f2f3;
    flex-wrap: wrap;
}

.modal-dialog-body-no-padding {
    display: flex;
    background-color: white;
    align-items: center;
    border-bottom: 3px solid #f3f2f3;
    flex-wrap: wrap;
}

.modal-dialog-body-line {
    width: 100%;
    text-align: center;
    text-wrap: wrap;
}

.modal-dialog-footer {
    display: flex;
    background-color: white;
    align-items: center;
    justify-content: center;
    color: #0048a4;
    font-weight: bold;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.modal-dialog-footer-button {
    width: 50%;
    padding: 20px 0;
    text-align: center;
}

.model-dialog-full-width-footer-button {
    padding: 20px 0;
    text-align: center;
    width: 100%;
}

.modal-dialog-footer-left-button {
    border-right: 3px solid #f3f2f3;
}

.modal-dialog-footer-text:hover {
    cursor: pointer;
}

.modal-dialog-footer-button:hover {
    cursor: pointer;
}

.modal-dialog-footer-left-button:hover {
    cursor: pointer;
}

.model-dialog-full-width-footer-button:hover {
    cursor: pointer;
}

@media screen and (max-width: 600px) {
    .modal-dialog {
        width: 95%;
    }

    .modal-dialog-header {
        height: 48px;
    }

    .modal-dialog-body {
        border-bottom: 1px solid #f3f2f3;
        /*padding: 15px;*/
    }

    .model-dialog-full-width-footer-button {
        padding-top: 10px;
        padding-bottom: 10px;
        text-align: center;
        width: 100%;
    }

    .modal-dialog-footer-left-button {
        border-right: 1px solid #f3f2f3;
    }

    .modal-dialog-footer-button {
        padding: 13px 0;
    }

    .modal-dialog-footer label {
        font-size: 12px;
    }
}

/*

@media screen and (max-width: 600px) {
    .modal-dialog {
        width: 80%;
    }

    .model-dialog-full-width-footer-button {
        padding-top: 10px;
        padding-bottom: 10px;
        text-align: center;
        width: 100%;
    }
}*/
`, "",{"version":3,"sources":["webpack://./src/shared/css/modal-dialog.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gCAAgC;QAChC,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;;;;;;;;;;;;EAaE","sourcesContent":[".modal-dialog {\n    width: 450px;\n}\n\n.modal-dialog-wide {\n    width: 550px;\n}\n\n.modal-dialog-header {\n    display: flex;\n    background-color: #0048a4;\n    color: white;\n    font-size: 18px;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    height: 62px;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.modal-dialog-body {\n    display: flex;\n    background-color: white;\n    align-items: center;\n    padding: 20px;\n    border-bottom: 3px solid #f3f2f3;\n    flex-wrap: wrap;\n}\n\n.modal-dialog-body-less-padding {\n    display: flex;\n    background-color: white;\n    align-items: center;\n    padding: 10px;\n    border-bottom: 3px solid #f3f2f3;\n    flex-wrap: wrap;\n}\n\n.modal-dialog-body-no-padding {\n    display: flex;\n    background-color: white;\n    align-items: center;\n    border-bottom: 3px solid #f3f2f3;\n    flex-wrap: wrap;\n}\n\n.modal-dialog-body-line {\n    width: 100%;\n    text-align: center;\n    text-wrap: wrap;\n}\n\n.modal-dialog-footer {\n    display: flex;\n    background-color: white;\n    align-items: center;\n    justify-content: center;\n    color: #0048a4;\n    font-weight: bold;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.modal-dialog-footer-button {\n    width: 50%;\n    padding: 20px 0;\n    text-align: center;\n}\n\n.model-dialog-full-width-footer-button {\n    padding: 20px 0;\n    text-align: center;\n    width: 100%;\n}\n\n.modal-dialog-footer-left-button {\n    border-right: 3px solid #f3f2f3;\n}\n\n.modal-dialog-footer-text:hover {\n    cursor: pointer;\n}\n\n.modal-dialog-footer-button:hover {\n    cursor: pointer;\n}\n\n.modal-dialog-footer-left-button:hover {\n    cursor: pointer;\n}\n\n.model-dialog-full-width-footer-button:hover {\n    cursor: pointer;\n}\n\n@media screen and (max-width: 600px) {\n    .modal-dialog {\n        width: 95%;\n    }\n\n    .modal-dialog-header {\n        height: 48px;\n    }\n\n    .modal-dialog-body {\n        border-bottom: 1px solid #f3f2f3;\n        /*padding: 15px;*/\n    }\n\n    .model-dialog-full-width-footer-button {\n        padding-top: 10px;\n        padding-bottom: 10px;\n        text-align: center;\n        width: 100%;\n    }\n\n    .modal-dialog-footer-left-button {\n        border-right: 1px solid #f3f2f3;\n    }\n\n    .modal-dialog-footer-button {\n        padding: 13px 0;\n    }\n\n    .modal-dialog-footer label {\n        font-size: 12px;\n    }\n}\n\n/*\n\n@media screen and (max-width: 600px) {\n    .modal-dialog {\n        width: 80%;\n    }\n\n    .model-dialog-full-width-footer-button {\n        padding-top: 10px;\n        padding-bottom: 10px;\n        text-align: center;\n        width: 100%;\n    }\n}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
